document.addEventListener("DOMContentLoaded", function () {
  var swiperlocation = new Swiper(".location__v2--imagesslider", {
    slidesPerView: 1,
    spaceBetween: 0,
    scrollbar: {
      el: ".swiper-scrollbar.location",
      draggable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.location",
      prevEl: ".swiper-button-prev.location",
    },
  });

  var buttonOne = document.querySelector(".location__v2btn");
  var buttonTwo = document.querySelector(".location__v2btnsec");
  var sliderNextBtn = document.querySelector(".swiper-button-next.location");
  var sliderPrevBtn = document.querySelector(".swiper-button-prev.location");

  if (buttonOne && buttonTwo && sliderNextBtn && sliderPrevBtn) {
    buttonOne.addEventListener("click", function (e) {
      e.preventDefault();
      buttonOne.classList.add("active");
      buttonTwo.classList.remove("active");
      swiperlocation.slideTo(0);
    });

    buttonTwo.addEventListener("click", function (e) {
      e.preventDefault();
      buttonTwo.classList.add("active");
      buttonOne.classList.remove("active");
      swiperlocation.slideTo(1);
    });

    swiperlocation.on('slideChange', function () {
      if (swiperlocation.activeIndex === 0) {
        buttonOne.classList.add("active");
        buttonTwo.classList.remove("active");
      } else if (swiperlocation.activeIndex === 1) {
        buttonTwo.classList.add("active");
        buttonOne.classList.remove("active");
      }
    });
  }
});
